export default {
  methods: {
    isAvailableValidator(selectedTestMethod, validator) {
      if (!selectedTestMethod || !validator.availableOnlyForTestMethods || validator.availableOnlyForTestMethods.length == 0) {
        return true;
      }

      return validator.availableOnlyForTestMethods.indexOf(selectedTestMethod) !== -1
    }
  }
}
